orders-today-calendar
  .line
    .cell-wrap(each="{cell in opts.cells}")
      .month(if="{cell.isShowMonth}") { cell.month }
      .month(if="{!cell.isShowMonth}")
      .day(class="day_{ cell.week }") { cell.day }
      .cell(class="cell_{ cell.week }") &nbsp;
  script(type="typescript").
    this.mixin('orders.today-calendar');
